import Show from '../show'

function ApDashboard() {
  return (
    <Show
      title="Accounts Payable Dashboard"
      dashboardKey="ap_dashboards"
      showYear={false}
    />
  )
}

export default ApDashboard
